module.exports = __webpack_public_path__ + "img/test_r9.2e066f43.png";